import React from 'react'
import { Breadcrumb, Card, Col, Form, FormGroup, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { setContactId, setEditContactEmail, setEditContactNamesurname, setEditContactPhone, setContactTrigger } from '../../redux/features/contacts.slice';
import { ApiRequest } from '../../api';

function ContactListEdit() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { contactTrigger, editContactNamesurname, editContactEmail, editContactPhone, contactId } = useSelector(state => state.contacts);

    /*====================== SWEETALERT START ======================*/
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
    /*====================== SWEETALERT END ======================*/
    /*======== POST CONTACT INFO AREA START ========*/
    const postContactData = (e) => {
        e.preventDefault();
        ApiRequest.putContact({ SystemCompanyId: localStorage.getItem("SystemCompanyId"), contactId: contactId }, {
            "email": editContactEmail,
            "nameSurname": editContactNamesurname,
            "phoneNumber": editContactPhone
        })
            .then(response => {
                Toast.fire({
                    icon: 'success',
                    title: 'Başarıyla eklendi!'
                })
                dispatch(setContactTrigger({ contactTrigger: !contactTrigger }))
                navigate(-1)
            })
            .catch(error => { console.log(error) })
    }
    /*======== POST CONTACT INFO AREA END ========*/

    const comeBack = () => {
        navigate(-1)
    }

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title">Kişi Bilgileri Düzenle</h1>
                    <Breadcrumb className="breadcrumb">
                        <Breadcrumb.Item className="breadcrumb-item" href="#">
                            Kişi Listesi
                        </Breadcrumb.Item>
                        <Breadcrumb.Item
                            className="breadcrumb-item active breadcrumds"
                            aria-current="page"
                        >
                            Kişi Bilgileri Düzenle
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>

            <div>
                <Card>
                    <Card.Header>
                        <Card.Title as="h3">Kişi Bilgileri</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row className='mb-3'>
                            <Col lg={6} md={12}>
                                <FormGroup>
                                    <label htmlFor="exampleInputContactNamesurname">İsim Soyisim</label>
                                    <Form.Control
                                        type="text"
                                        className="form-control"
                                        id="exampleInputContactNamesurname"
                                        defaultValue={editContactNamesurname}
                                        onChange={(e) => dispatch(setEditContactNamesurname({ editContactNamesurname: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={6} md={12}>
                                <FormGroup>
                                    <label htmlFor="exampleInputContactEmail">Email</label>
                                    <Form.Control
                                        type="email"
                                        className="form-control"
                                        id="exampleInputContactEmail"
                                        defaultValue={editContactEmail}
                                        onChange={(e) => dispatch(setEditContactEmail({ editContactEmail: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={12}>
                                <FormGroup>
                                    <label htmlFor="exampleInputContactNumber">Telefon</label>
                                    <Form.Control
                                        type="tel"
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        className="form-control"
                                        id="exampleInputContactNumber"
                                        defaultValue={editContactPhone}
                                        onChange={(e) => dispatch(setEditContactPhone({ editContactPhone: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer className="text-end">
                        <a to="#" onClick={postContactData} className="btn btn-primary text-white mt-1 me-2">
                            Kaydet
                        </a>
                        <a href='#' onClick={comeBack} className="btn btn-danger mt-1 me-2">
                            Vazgeç
                        </a>
                    </Card.Footer>
                </Card>
            </div>
        </div>
    )
}

export default ContactListEdit